import type {
  BlockRoomRequestDto,
  CreateHousekeepingTaskRequestDto,
  ReleaseRoomBlockRequestDto,
  ReportMaintenanceIssueRequestDto,
  UpdateHousekeepingTaskRequestDto,
  UpdateMaintenanceReportRequestDto,
  UpdateRoomStateRequestDto,
} from "./dtos.ts";

function requireValue(value: string | undefined, message: string) {
  return value?.trim() ? "" : message;
}

export function validateCreateHousekeepingTaskRequest(request: CreateHousekeepingTaskRequestDto) {
  return {
    taskId: requireValue(request.taskId, "Task id is required."),
    roomId: requireValue(request.roomId, "Room is required."),
  };
}

export function validateUpdateHousekeepingTaskRequest(request: UpdateHousekeepingTaskRequestDto) {
  return {
    taskId: requireValue(request.taskId, "Task id is required."),
    roomId: requireValue(request.roomId, "Room is required."),
    status: requireValue(request.status, "Task status is required."),
  };
}

export function validateUpdateRoomStateRequest(request: UpdateRoomStateRequestDto) {
  return {
    roomId: requireValue(request.roomId, "Room is required."),
    source: requireValue(request.source, "Update source is required."),
    expectedRevision: Number.isInteger(request.expectedRevision) && request.expectedRevision >= 0
      ? ""
      : "Expected room revision is required.",
    patch:
      request.housekeepingStatus || request.availabilityStatus
        ? ""
        : "At least one room-state field must be updated.",
  };
}

export function validateReportMaintenanceIssueRequest(request: ReportMaintenanceIssueRequestDto) {
  return {
    reportId: requireValue(request.reportId, "Report id is required."),
    roomId: requireValue(request.roomId, "Room is required."),
    title: requireValue(request.title, "Title is required."),
    description: requireValue(request.description, "Description is required."),
    expectedRoomRevision: Number.isInteger(request.expectedRoomRevision) && request.expectedRoomRevision >= 0
      ? ""
      : "Expected room revision is required.",
  };
}

export function validateUpdateMaintenanceReportRequest(request: UpdateMaintenanceReportRequestDto) {
  return {
    reportId: requireValue(request.reportId, "Report id is required."),
    roomId: requireValue(request.roomId, "Room is required."),
    status: requireValue(request.status, "Report status is required."),
  };
}

export function validateBlockRoomRequest(request: BlockRoomRequestDto) {
  return {
    blockId: requireValue(request.blockId, "Block id is required."),
    roomId: requireValue(request.roomId, "Room is required."),
    reason: requireValue(request.reason, "Reason is required."),
    from: requireValue(request.from, "Start date is required."),
    expectedRoomRevision: Number.isInteger(request.expectedRoomRevision) && request.expectedRoomRevision >= 0
      ? ""
      : "Expected room revision is required.",
  };
}

export function validateReleaseRoomBlockRequest(request: ReleaseRoomBlockRequestDto) {
  return {
    blockId: requireValue(request.blockId, "Block id is required."),
    roomId: requireValue(request.roomId, "Room is required."),
    expectedRoomRevision: Number.isInteger(request.expectedRoomRevision) && request.expectedRoomRevision >= 0
      ? ""
      : "Expected room revision is required.",
  };
}
